module.exports = __webpack_public_path__ + "assets/img/246401.ab515eb7.svg";